import { t } from "i18next";
import { NotificationDataType } from "../Domain/NotificationSettings.types";

export const generateDescription = (subject: NotificationDataType, time: number) => {
  switch (subject) {
    case NotificationDataType.BOOKING_APPROVAL_ADMIN:
      return t("_notificationSettingDescription_BOOKING_APPROVAL_ADMIN");
    case NotificationDataType.BOOKING_APPROVAL_APPROVED:
      return t("_notificationSettingDescription_BOOKING_APPROVAL_APPROVED");
    case NotificationDataType.BOOKING_APPROVAL_REJECTED:
      return t("_notificationSettingDescription_BOOKING_APPROVAL_REJECTED");
    case NotificationDataType.BOOKING_APPROVAL_REQUEST:
      return t("_notificationSettingDescription_BOOKING_APPROVAL_REQUEST");

    case NotificationDataType.SUPERVISOR_EMPLOYEE_CREATE:
      return t("_notificationSettingDescription_SUPERVISOR_EMPLOYEE_CREATE");
    case NotificationDataType.SUPERVISOR_EMPLOYEE_DELETE:
      return t("_notificationSettingDescription_SUPERVISOR_EMPLOYEE_DELETE");
    case NotificationDataType.SUPERVISOR_EMPLOYEE_INACTIVATE:
      return t("_notificationSettingDescription_SUPERVISOR_EMPLOYEE_INACTIVATE");

    case NotificationDataType.NOT_BOOKED_REMINDER:
      return t("_notificationSettingDescription_NOT_BOOKED_REMINDER");
    case NotificationDataType.TEAM_BOOKING:
      return t("_notificationSettingDescription_TEAM_BOOKING");

    // time-related
    case NotificationDataType.BOOKING_START_REMINDER:
      return t("_notificationSettingDescription_BOOKING_START_REMINDER", { time: time });
    case NotificationDataType.BOOKING_END_REMINDER:
      return t("_notificationSettingDescription_BOOKING_END_REMINDER", { time: time });
    case NotificationDataType.BOOKING_INACTIVATION_ALERT:
      return t("_notificationSettingDescription_BOOKING_INACTIVATION_ALERT");
    case NotificationDataType.BOOKING_CHECKIN_REMINDER:
      return t("_notificationSettingDescription_BOOKING_CHECKIN_REMINDER", { time: time });

    // service
    case NotificationDataType.SERVICE_QUANTITY_CHANGE:
      return t("_notificationSettingDescription_SERVICE_QUANTITY_CHANGE");
    case NotificationDataType.SERVICE_STATUS_INFO:
      return t("_notificationSettingDescription_SERVICE_STATUS_INFO");

    // colleague inquiry
    case NotificationDataType.COLLEAGUE_INQUIRY:
      return t("_notificationSettingDescription_COLLEAGUE_INQUIRY");

    // fleet
    case NotificationDataType.FLEET_BOOKING_START_REMINDER:
      return t("_notificationSettingDescription_FLEET_BOOKING_START_REMINDER", { time: time });
    case NotificationDataType.FLEET_BOOKING_END_REMINDER:
      return t("_notificationSettingDescription_FLEET_BOOKING_END_REMINDER", {
        time: time
      });
    case NotificationDataType.FLEET_ADMIN_BOOKING_START_REMINDER:
      return t("_notificationSettingDescription_FLEET_ADMIN_BOOKING_START_REMINDER", {
        time: time
      });
    case NotificationDataType.FLEET_ADMIN_BOOKING_END_REMINDER:
      return t("_notificationSettingDescription_FLEET_ADMIN_BOOKING_END_REMINDER", {
        time: time
      });
    case NotificationDataType.FLEET_ADMIN_CHECKIN_REMINDER:
      return t("_notificationSettingDescription_FLEET_ADMIN_CHECKIN_REMINDER", { time: time });
    case NotificationDataType.FLEET_BOOKING_CREATED_FOR_ME:
      return t("_notificationSettingDescription_FLEET_BOOKING_CREATED_FOR_ME");
    case NotificationDataType.FLEET_BOOKING_TIME_CHANGED:
      return t("_notificationSettingDescription_FLEET_BOOKING_TIME_CHANGED");
    default:
      return t("Notification");
  }
};

export const generateTimeRelatedDescription = (subject: NotificationDataType) => {
  switch (subject) {
    // booking
    case NotificationDataType.BOOKING_START_REMINDER:
      return t("_notificationTimeRelatedSettingBodyText_BOOKING_START_REMINDER");
    case NotificationDataType.BOOKING_END_REMINDER:
      return t("_notificationTimeRelatedSettingBodyText_BOOKING_END_REMINDER");

    // fleet
    case NotificationDataType.FLEET_BOOKING_START_REMINDER:
      return t("_notificationTimeRelatedSettingBodyText_FLEET_BOOKING_START_REMINDER");
    case NotificationDataType.FLEET_ADMIN_BOOKING_START_REMINDER:
      return t("_notificationTimeRelatedSettingBodyText_FLEET_ADMIN_BOOKING_START_REMINDER");
    case NotificationDataType.FLEET_BOOKING_END_REMINDER:
      return t("_notificationTimeRelatedSettingBodyText_FLEET_BOOKING_END_REMINDER");
    case NotificationDataType.FLEET_ADMIN_BOOKING_END_REMINDER:
      return t("_notificationTimeRelatedSettingBodyText_FLEET_ADMIN_BOOKING_END_REMINDER");
    case NotificationDataType.BOOKING_CHECKIN_REMINDER:
      return t("_notificationTimeRelatedSettingBodyText_BOOKING_CHECKIN_REMINDER");
    case NotificationDataType.FLEET_ADMIN_CHECKIN_REMINDER:
      return t("_notificationTimeRelatedSettingBodyText_FLEET_ADMIN_CHECKIN_REMINDER");
    // case NotificationDataType.FLEET_BOOKING_CREATED_FOR_ME:
    //   return t("_notificationTimeRelatedSettingBodyText_FLEET_BOOKING_CREATED_FOR_ME");
    // case NotificationDataType.FLEET_BOOKING_TIME_CHANGED:
    //   return t("_notificationTimeRelatedSettingBodyText_FLEET_BOOKING_TIME_CHANGED");
  }
};
